import { API_URL as BASE_URL } from '../../lib/config';
const API_URL = `${BASE_URL}/platform-admin`;

export interface DashboardStats {
  organizations: {
    total: number;
    active: number;
    paused: number;
    trial: number;
  };
  users: {
    total: number;
    active: number;
    last24Hours: number;
  };
  systemEvents: {
    total24Hours: number;
    pending: number;
    critical: number;
    bySeverity: Array<{ severity: string; count: number }>;
  };
  usage: {
    apiCalls24h: number;
    totalStorage: number;
    activeIntegrations: number;
  };
  recentActivity: {
    newOrganizations7d: number;
    newUsers7d: number;
    resolvedEvents7d: number;
  };
}

export const dashboardService = {
  async getStats(token: string): Promise<DashboardStats> {
    const response = await fetch(`${API_URL}/dashboard/stats`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch dashboard stats');
    }

    return response.json();
  },
};
